export const INTERVAL_TIME = 1000;
export const HOURS = 24;
export const MINUTES = 60;
export const SECONDS = 60;
export const EXPIRATION_TIME = 432000; // 5 days
